@if (label) {
  <app-control-header
    [label]="label"
    [icon]="labelIcon"
    [index]="index"
    [required]="required"
  ></app-control-header>
}

<input
  #multipleFileUploadField
  hidden
  multiple
  type="file"
  [accept]="acceptedFileExtensionsString"
  [disabled]="isDisabled$ | async"
  (change)="changeMultipleFiles()"
/>

<input
  #singleFileUploadField
  hidden
  type="file"
  [accept]="acceptedFileExtensionsString"
  (change)="changeSingleFile()"
/>

@if (selectFilesTrigger) {
  <div role="button" (click)="openAddFilesModal()">
    <ng-container *ngTemplateOutlet="selectFilesTrigger"></ng-container>
  </div>
} @else {
  @if (!displayFilesSeparated || !hasValue) {
    <ng-container *ngTemplateOutlet="fileRow"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="separatedFiles"></ng-container>
  }
}

<ng-template #separatedFiles>
  <div class="flex flex-col gap-y-4">
    @if (hasValue) {
      @for (file of valueAsFileArray; track index; let index = $index) {
        <ng-container *ngTemplateOutlet="separateFileRow; context: { fileIndex: index }"></ng-container>
      }
    }

    @if (displayFilesSeparated && hasValue) {
      <app-new-button
        class="pr-14"
        [type]="'basic'"
        [size]="'responsive'"
        [svgIconPath]="'Add'"
        (click)="openAddFilesModal()"
      >
        {{ buildTranslationKey('addAnotherFile') | translate }}
      </app-new-button>
    }
  </div>
</ng-template>

<ng-template #fileRow let-fileIndex="fileIndex">
  <div class="flex flex-row gap-4 w-full">
    <div
      class="file-wrapper"
      [class.is-disabled]="isDisabled$ | async"
      [class.file-changed]="hasValue"
      [ngClass]="{ 'border border-solid border-pink-70': errorsDisplayed }"
      (click)="displayFilesSeparated && hasValue ? openChangeFileModal(fileIndex) : openAddFilesModal()"
    >
      <div class="text-wrapper">
        @if (!hasValue) {
          <span>
            {{ buildTranslationKey('selectFiles') | translate }}
          </span>
        } @else {
          <ng-container *ngTemplateOutlet="uploadedFilesTemplate; context: { fileIndex: fileIndex }"></ng-container>
        }
      </div>
    </div>

    @if (displayFilesSeparated && hasValue) {
      <app-icon-button
        class="self-end"
        type="basic"
        svgIconPath="remove"
        (click)="removeFile(fileIndex)"
      ></app-icon-button>
    }
  </div>
</ng-template>

<ng-template #separateFileRow let-fileIndex="fileIndex">
  <div *ngVar="isFileTypeValid(fileIndex) as isFileTypeValid"  class="flex flex-col w-full">
    <div class="flex w-full gap-x-4 relative">
      <div
        class="file-wrapper"
        [class.is-disabled]="isDisabled$ | async"
        [class.file-changed]="hasValue"
        [ngClass]="{ 'border border-solid border-pink-70': !hasValue && errorsDisplayed || hasValue && !isFileTypeValid }"
        (click)="displayFilesSeparated && hasValue ? openChangeFileModal(fileIndex) : openAddFilesModal()"
      >
        <div class="text-wrapper">
          @if (!hasValue) {
            <span>
              {{ buildTranslationKey('selectFiles') | translate }}
            </span>
          } @else {
            <ng-container *ngTemplateOutlet="uploadedFilesTemplate; context: { fileIndex: fileIndex }"></ng-container>
          }
        </div>
      </div>

      @if (displayFilesSeparated && hasValue) {
        <app-icon-button
          class="self-end"
          type="basic"
          svgIconPath="remove"
          (click)="removeFile(fileIndex)"
        ></app-icon-button>
      }
    </div>

    @if (acceptedFileExtensions?.length && hasValue && displayFilesSeparated && !isFileTypeValid) {
      <span class="font-main m-1 inline text-error text-sm">
        {{ buildTranslationKey('errorFileType') | translate }}
      </span>
    }
  </div>
</ng-template>

<ng-template #uploadedFilesTemplate let-fileIndex="fileIndex">
  <span class="file-name">
    {{
      displayFilesSeparated
        ? value[fileIndex].name
        : (fileNamePlaceholder | translate: { files_count: filesCount })
    }}
  </span>
</ng-template>

@if (dirty || !validateOnDirty) {
  <app-control-errors
    [errorTexts]="errorTexts"
    [errorInfoIconTexts]="errorInfoIconTexts"
    [displayedErrorsLength]="1"
  ></app-control-errors>
}
